import { Component, Input, Output } from 'angular-ts-decorators';
import { CustomizerFilter, FilterOption } from '../../models';
import { IHeroCustomizerV2FilterComponent } from '../models/hero-customizer-v2.filter.component';

import template from './hero-customizer-v2.filter-radio.component.html';

@Component({
  selector: 'heroCustomizerV2FilterRadio',
  template,
})
export class HeroCustomizerV2FilterRadioComponent implements IHeroCustomizerV2FilterComponent {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public filter?: CustomizerFilter;

  @Output() public onFilterChange?: ({ filter: CustomizerFilter }) => void;

  public onOptionClicked(option: FilterOption) {
    if (option.checked) {
      return;
    }

    this.filter.options.forEach((x: FilterOption) => { x.checked = false; });
    option.checked = true;
    if (this.onFilterChange) {
      this.onFilterChange({ filter: this.filter });
    }
  }
}
